import React, { useState,  forwardRef, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import { AuthorizeContext } from "../RootContext";
import { Link, useParams } from 'react-router-dom';
import { api_url } from "../authorize";
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import logo from './../img/lento_logo_transparent.png';
import moment from 'moment';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import MaterialTable from 'material-table';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import FlagIcon from '@material-ui/icons/Flag';


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} fontSize="large"/>),
    SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    Flag: forwardRef((props, ref) => <FlagIcon {...props} ref={ref} />),
  };
  const useStyles = makeStyles((theme) => ({
    page: {
      minHeight: 'calc(100vh - 64px)',
      padding: '22px 10px 42px',
      boxSizing: 'border-box',
      background:
        'radial-gradient(circle at 8% 0%, rgba(49, 178, 164, 0.12) 0, transparent 28%), radial-gradient(circle at 96% 2%, rgba(42, 123, 184, 0.10) 0, transparent 30%), linear-gradient(180deg, #f8fbfc 0%, #edf4f7 100%)',
      color: '#173247',

      [theme.breakpoints.down('sm')]: {
        padding: '16px 6px 30px',
      },
    },

    shell: {
      width: '100%',
      maxWidth: 'none',
      margin: '0 auto',
    },

    hero: {
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 28,
      padding: '28px 30px',
      border: '1px solid rgba(255, 255, 255, 0.30)',
      borderRadius: 20,
      background: 'linear-gradient(135deg, #153f5c 0%, #0d7289 58%, #21998f 100%)',
      boxShadow: '0 18px 42px rgba(19, 73, 99, 0.18)',

      '&::after': {
        content: '\"\"',
        position: 'absolute',
        width: 220,
        height: 220,
        right: -74,
        top: -106,
        borderRadius: '50%',
        border: '32px solid rgba(255, 255, 255, 0.07)',
        pointerEvents: 'none',
      },

      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-start',
        flexDirection: 'column',
        padding: '24px 20px',
      },
    },

    heroCopy: {
      position: 'relative',
      zIndex: 1,
      minWidth: 0,
    },

    eyebrow: {
      margin: 0,
      color: 'rgba(255, 255, 255, 0.72)',
      fontSize: 11,
      fontWeight: 900,
      letterSpacing: '0.14em',
      textTransform: 'uppercase',
    },

    heroTitle: {
      margin: '6px 0 0',
      color: '#ffffff',
      fontSize: 32,
      fontWeight: 850,
      lineHeight: 1.15,
      letterSpacing: '-0.035em',

      [theme.breakpoints.down('xs')]: {
        fontSize: 27,
      },
    },

    heroSubtitle: {
      maxWidth: 720,
      margin: '9px 0 0',
      color: 'rgba(255, 255, 255, 0.82)',
      fontSize: 14,
      lineHeight: 1.55,
    },

    heroMeta: {
      position: 'relative',
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      gap: 22,
      flexWrap: 'wrap',
      justifyContent: 'flex-end',

      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',
      },
    },

    metaPill: {
      display: 'inline-flex',
      alignItems: 'center',
      minHeight: 0,
      padding: 0,
      border: 0,
      borderRadius: 0,
      background: 'transparent',
      boxShadow: 'none',
      color: 'rgba(255, 255, 255, 0.92)',
      fontSize: 14,
      fontWeight: 750,
      lineHeight: 1.4,
      backdropFilter: 'none',
      whiteSpace: 'nowrap',
    },

    actionBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      marginTop: 18,
      padding: '14px 16px',
      border: '1px solid #dbe7ec',
      borderRadius: 15,
      background: 'rgba(255, 255, 255, 0.92)',
      boxShadow: '0 9px 24px rgba(23, 70, 94, 0.07)',

      [theme.breakpoints.down('sm')]: {
        alignItems: 'stretch',
        flexDirection: 'column',
      },
    },

    actionCopy: {
      minWidth: 0,
    },

    actionTitle: {
      margin: 0,
      color: '#213f53',
      fontSize: 14,
      fontWeight: 850,
    },

    actionHint: {
      margin: '3px 0 0',
      color: '#748895',
      fontSize: 12,
      lineHeight: 1.45,
    },

    actionButtons: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      flexWrap: 'wrap',

      [theme.breakpoints.down('xs')]: {
        '& > button': {
          width: '100%',
        },
      },
    },

    actionButton: {
      minHeight: 40,
      padding: '0 17px',
      border: '1px solid transparent',
      borderRadius: 10,
      fontFamily: 'inherit',
      fontSize: 13,
      fontWeight: 850,
      cursor: 'pointer',
      transition: 'transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease',

      '&:hover': {
        transform: 'translateY(-1px)',
      },

      '&:focus': {
        outline: 'none',
        boxShadow: '0 0 0 4px rgba(36, 155, 180, 0.14)',
      },
    },

    primaryButton: {
      color: '#ffffff',
      background: 'linear-gradient(135deg, #169ab4 0%, #0b7189 100%)',
      boxShadow: '0 8px 18px rgba(11, 113, 137, 0.20)',
    },

    secondaryButton: {
      color: '#31566d',
      borderColor: '#d4e2e8',
      background: '#ffffff',
      boxShadow: '0 6px 15px rgba(24, 69, 92, 0.06)',
    },

    tableCard: {
      overflow: 'hidden',
      marginTop: 18,
      border: '1px solid #d9e6eb',
      borderRadius: 18,
      background: '#ffffff',
      boxShadow: '0 18px 44px rgba(25, 70, 95, 0.10)',

      '& .MuiPaper-root': {
        borderRadius: '0 !important',
        boxShadow: 'none !important',
      },

      '& .MuiToolbar-root': {
        minHeight: '60px !important',
        padding: '0 12px !important',
        borderBottom: '1px solid #e4ecef',
        background: '#ffffff',
      },

      '& .MuiToolbar-root .MuiInputBase-root': {
        minHeight: 46,
        padding: '0 13px',
        fontSize: '14px',
        border: '1px solid #d3e1e7',
        borderRadius: 10,
        background: '#f9fbfc',
      },

      '& .MuiTableContainer-root': {
        width: '100% !important',
        maxWidth: '100% !important',
        minWidth: '0 !important',
        overflowX: 'hidden !important',
        scrollbarWidth: 'none',
      },

      '& .MuiTableContainer-root::-webkit-scrollbar': {
        display: 'none',
        width: 0,
        height: 0,
      },

      '& .MuiPaper-root > div': {
        maxWidth: '100% !important',
      },

      '& .MuiTable-root': {
        width: '100% !important',
        maxWidth: '100% !important',
        minWidth: '0 !important',
        tableLayout: 'fixed !important',
        borderCollapse: 'collapse !important',
        borderSpacing: '0 !important',
      },

      // MaterialTable generates pixel widths in a colgroup. Removing that
      // sizing lets the CSS column percentages below control the real layout.
      '& .MuiTable-root colgroup': {
        display: 'none !important',
      },

      '& .MuiTable-root colgroup col': {
        width: 'auto !important',
        minWidth: '0 !important',
        maxWidth: 'none !important',
      },

      '& .MuiTableCell-root': {
        minWidth: '0 !important',
        maxWidth: 'none !important',
        boxSizing: 'border-box',
      },

      '& .MuiTableCell-head': {
        padding: '13px 2px !important',
        borderBottom: '1px solid #dce7eb !important',
        background: '#f2f7f9 !important',
        color: '#345064 !important',
        fontSize: '14.5px !important',
        fontWeight: '850 !important',
        lineHeight: '1.25 !important',
        whiteSpace: 'normal !important',
        overflowWrap: 'anywhere',
        textAlign: 'center',
      },

      // Make the visible heading sit in the exact center of its column.
      // The sort arrow is positioned separately so it cannot push the label.
      '& .MuiTableCell-head > div, & .MuiTableCell-head > span': {
        width: '100% !important',
        minWidth: '0 !important',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        textAlign: 'center !important',
      },

      '& .MuiTableSortLabel-root': {
        position: 'relative !important',
        width: '100% !important',
        minWidth: '0 !important',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        textAlign: 'center !important',
      },

      '& .MuiTableSortLabel-icon': {
        position: 'absolute !important',
        right: '0 !important',
        margin: '0 !important',
      },

      '& .MuiTableCell-body': {
        padding: '14px 2px !important',
        borderBottom: '1px solid #edf2f4 !important',
        color: '#263f50',
        fontSize: '14px !important',
        lineHeight: '1.45 !important',
        verticalAlign: 'middle',
        overflow: 'hidden',
        overflowWrap: 'anywhere',
        wordBreak: 'break-word',
        textOverflow: 'ellipsis',
        textAlign: 'center !important',
      },

      // Keep every value directly beneath its column heading, including
      // links, boolean symbols, status values, and action controls.
      '& .MuiTableCell-body > div': {
        width: '100% !important',
        minWidth: '0 !important',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        flexWrap: 'wrap',
        gap: 2,
        textAlign: 'center !important',
      },

      '& .MuiTableCell-body a': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '100%',
        textAlign: 'center',
      },

      '& .MuiTableCell-body > svg, & .MuiTableCell-body > .MuiSvgIcon-root': {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
      },

      '& .MuiTableCell-body .MuiCheckbox-root': {
        display: 'flex',
        width: 'fit-content',
        marginLeft: 'auto',
        marginRight: 'auto',
      },

      '& .MuiTableCell-body .MuiInputBase-root': {
        width: '100%',
        justifyContent: 'center',
        textAlign: 'center',
      },

      '& .MuiTableCell-body .MuiInputBase-input, & .MuiTableCell-body .MuiSelect-select': {
        textAlign: 'center !important',
        textAlignLast: 'center',
      },

      '& .MuiTableRow-root': {
        transition: 'background-color 120ms ease',
      },

      '& .MuiTableRow-root:hover .MuiTableCell-body': {
        backgroundColor: '#f6fafb',
      },

      '& .MuiTableCell-body a': {
        color: '#0a718b',
        fontWeight: 850,
        textDecoration: 'none',
      },

      '& .MuiTableCell-body a:hover': {
        textDecoration: 'underline',
      },

      '& .MuiIconButton-root': {
        padding: '3px !important',
        color: '#4a687a',
      },

      '& .MuiSvgIcon-root': {
        fontSize: '21px !important',
      },

      '& .MuiIconButton-root:hover': {
        background: '#eaf4f7',
        color: '#0b7189',
      },

      '& .MuiTablePagination-root': {
        width: '100% !important',
        maxWidth: '100% !important',
        overflow: 'hidden !important',
        borderTop: '1px solid #e5edf0',
        color: '#526b7b',
        background: '#ffffff',
      },

      // Keep the row selector and page buttons fully visible without an
      // internal horizontal scrollbar.
      '& .MuiTablePagination-toolbar': {
        width: '100% !important',
        maxWidth: '100% !important',
        minWidth: '0 !important',
        minHeight: '72px !important',
        padding: '10px 16px !important',
        boxSizing: 'border-box',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'flex-end !important',
        flexWrap: 'nowrap !important',
        overflow: 'hidden !important',
      },

      '& .MuiTablePagination-spacer': {
        flex: '1 1 auto !important',
        minWidth: '0 !important',
      },

      '& .MuiTablePagination-caption': {
        flexShrink: 0,
        margin: '0 8px !important',
        fontSize: '14px !important',
        fontWeight: 700,
        whiteSpace: 'nowrap',
      },

      '& .MuiTablePagination-selectRoot': {
        flexShrink: 0,
        minWidth: '102px !important',
        minHeight: '46px !important',
        marginLeft: '8px !important',
        marginRight: '10px !important',
        padding: '0 8px !important',
        display: 'inline-flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        border: '1px solid #cddde4',
        borderRadius: 10,
        background: '#f9fbfc',
        boxSizing: 'border-box',
      },

      '& .MuiTablePagination-select': {
        minWidth: '58px !important',
        paddingLeft: '10px !important',
        paddingRight: '24px !important',
        fontSize: '14px !important',
        fontWeight: 700,
        textAlign: 'center',
        textAlignLast: 'center',
      },

      '& .MuiTablePagination-actions': {
        flexShrink: 0,
        display: 'flex !important',
        alignItems: 'center !important',
        gap: 2,
        marginLeft: '4px !important',
        overflow: 'visible !important',
      },

      '& .MuiTablePagination-actions .MuiIconButton-root': {
        width: '40px !important',
        height: '40px !important',
        padding: '8px !important',
      },

      '& .MuiTablePagination-actions .MuiSvgIcon-root': {
        fontSize: '20px !important',
      },

      '& .MuiTablePagination-root::-webkit-scrollbar, & .MuiTablePagination-toolbar::-webkit-scrollbar': {
        display: 'none !important',
        width: 0,
        height: 0,
      },

      '& .MuiInput-underline:before, & .MuiInput-underline:after': {
        borderBottom: '0 !important',
      },

      '& .MuiTableCell-head .MuiInputBase-root': {
        width: '100% !important',
        minWidth: '0 !important',
        fontSize: '12.5px !important',
        justifyContent: 'center',
        textAlign: 'center',
      },

      '& .MuiTableCell-head .MuiInputBase-input': {
        textAlign: 'center !important',
      },

      '& .MuiTableCell-head .MuiSelect-select': {
        paddingRight: '14px !important',
        paddingLeft: '14px !important',
        textAlign: 'center !important',
        textAlignLast: 'center',
      },

      '& .MuiTableCell-head .MuiIconButton-root': {
        display: 'flex',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },


    adminTable: {
      // These percentages total 100% and are shared by the header and body.
      // This prevents the final Tibia Slot column from extending off-screen.
      '& .MuiTableCell-root:nth-child(1)': { width: '6.5% !important' },
      '& .MuiTableCell-root:nth-child(2)': { width: '5% !important' },
      '& .MuiTableCell-root:nth-child(3)': { width: '8% !important' },
      '& .MuiTableCell-root:nth-child(4)': { width: '7% !important' },
      '& .MuiTableCell-root:nth-child(5)': { width: '7% !important' },
      '& .MuiTableCell-root:nth-child(6)': { width: '6.5% !important' },
      '& .MuiTableCell-root:nth-child(7)': { width: '6.5% !important' },
      '& .MuiTableCell-root:nth-child(8)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(9)': { width: '5% !important' },
      '& .MuiTableCell-root:nth-child(10)': { width: '4% !important' },
      '& .MuiTableCell-root:nth-child(11)': { width: '6.5% !important' },
      '& .MuiTableCell-root:nth-child(12)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(13)': { width: '6.5% !important' },
      '& .MuiTableCell-root:nth-child(14)': { width: '7.5% !important' },
      '& .MuiTableCell-root:nth-child(15)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(16)': { width: '6% !important' },

      '& .MuiTableCell-head, & .MuiTableCell-body': {
        minWidth: '0 !important',
        maxWidth: 'none !important',
      },
    },

    tableScroller: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
      overflowX: 'hidden !important',
      WebkitOverflowScrolling: 'touch',
    },

    loadingScreen: {
      position: 'fixed',
      top: 72,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1200,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      background: '#ffffff',
    },

    loadingLogoWrap: {
      width: 'min(680px, 62vw)',
      maxWidth: 'calc(100vw - 48px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      [theme.breakpoints.down('sm')]: {
        width: 'min(520px, 78vw)',
      },

      [theme.breakpoints.down('xs')]: {
        width: 'min(390px, 86vw)',
      },
    },

    loadingLogo: {
      display: 'block',
      width: '100%',
      height: 'auto',
      objectFit: 'contain',
      background: 'transparent',
      filter: 'none',
    },

    dialogPaper: {
      width: 'min(100%, 520px)',
      borderRadius: '16px !important',
      boxShadow: '0 24px 60px rgba(20, 55, 74, 0.24) !important',
    },

    dialogTitle: {
      margin: 0,
      color: '#7f302c',
      fontSize: 21,
      fontWeight: 850,
      lineHeight: 1.25,
    },

    dialogText: {
      color: '#526b7b !important',
      fontSize: '14px !important',
      lineHeight: '1.65 !important',
    },

    dialogActions: {
      gap: 10,
      padding: '12px 24px 22px !important',
    },

    dangerButton: {
      minWidth: 92,
      minHeight: 40,
      border: 0,
      borderRadius: 9,
      color: '#ffffff',
      background: '#b5453f',
      fontFamily: 'inherit',
      fontSize: 13,
      fontWeight: 850,
      cursor: 'pointer',
    },

    cancelButton: {
      minWidth: 92,
      minHeight: 40,
      border: '1px solid #d5e1e6',
      borderRadius: 9,
      color: '#405d70',
      background: '#ffffff',
      fontFamily: 'inherit',
      fontSize: 13,
      fontWeight: 850,
      cursor: 'pointer',
    },
  }));

  const theme = createTheme({
    palette: {
      primary: { main: '#0b7b93' },
      secondary: { main: '#325d73' },
      background: { default: '#f4f8fa', paper: '#ffffff' },
    },
    typography: {
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif',
      h6: { fontSize: '1.05rem', fontWeight: 800 },
      body1: { fontSize: '0.875rem' },
      body2: { fontSize: '0.8125rem' },
    },
    overrides: {
      MuiTooltip: {
        tooltip: {
          fontSize: '0.72rem',
          borderRadius: 7,
        },
      },
    },
  });

const ActiveList = () => {
  const classes = useStyles();
  const { token, role, user, authBody, setAuthBody, setAuthenticated } = useContext(AuthorizeContext);
  const [data, setData] = useState({})
  const [columnFilters, setColumnFilters ]= useState({});
  let temp = [];
  const [loading, setLoading] = useState(true);
  let { surgeonid } = useParams();
  const [profile, setProfile] = useState(authBody || {role: "visitor"});
  const hasRole = (profile, roles) =>{
    return roles.includes(role);
  };

  let tableRef = useRef(MaterialTable);

const clearFilter = () => {
        
    localStorage.removeItem('columnFilters');
   window.location.reload();
    }

const SaveFilterData = (thing) =>{
  console.log(tableRef.current.state)
  if (tableRef.current.dataManager.filteredData <1){
    localStorage.removeItem('columnFilters');
    localStorage.setItem('columnFilters',JSON.stringify(tableRef.current.state.originalData));
    // useEffect();
    //alert("Filter has returned no Results.\n\n Refreshing to Full Data SET")

   // window.location.reload();
  }
  else{
    localStorage.setItem('columnFilters',JSON.stringify(tableRef.current.dataManager.filteredData));
  }
}
  console.log(data)
  useEffect(() => {
      let savedFilters = JSON.parse(localStorage.getItem('columnFilters'));
      console.log(savedFilters)
      if (savedFilters || JSON.stringify(savedFilters) > 5) {

        setColumnFilters(savedFilters);
      console.log("Saved Filters are here -->");
      }
      else{ savedFilters= 0}

    ////////////////////////
    const fetchData = async () => {
      if (role.includes("admin") && savedFilters){
        setLoading(false)
        setState((prevState) => ({
          ...prevState, data: savedFilters
        }));
      }
      else if (role.includes("admin") && !savedFilters){
        const admin = await axios({
          url: `https://${api_url}/api/case_list?status=active`,
          method: 'get',
          headers: {
            'x-access-token' : token
          }
        })

        setLoading(false)
        setState((prevState) => ({
          ...prevState, data: admin.data
        }))

      }
      else if(role.includes("hospital")){
        const hos = await axios({
          url: `https://${api_url}/api/hospital_list?for_hospital=true&status=active`,
          method: 'get',
          headers: {
            'x-access-token' : token
          }
        })

          console.log(hos)
          setLoading(false)

          setState((prevState) => ({
            ...prevState, data: hos.data.active
          })) 
      }

      else if(role.includes("distributor")){
        const dis = await axios({
          url: `https://${api_url}/api/distributor_list?for_distributor=true&status=active`,
          method: 'get',
          headers: {
            'x-access-token' : token
          }
        })

        console.log(dis)
        setLoading(false)

        setState((prevState) => ({
          ...prevState, data: dis.data
        }))
      }
      else{
          const res = await axios({
            url: `https://${api_url}/api/case_list?${role}=${user.Email_Address}&surgeon=${surgeonid}&status=active`,
            method: 'get',
            headers: {
              'x-access-token' : token
            }
          })
        setLoading(false)

        setState((prevState) => ({
          ...prevState, data: res.data
        }))
      }
    }
    fetchData()

  }, [setState]);

  let lookup = hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ?
    {
      1: "New Order",
      2: 'MRI',
      3: 'MRI QC',
      4: 'Planning 1',
      5: 'Planning 2',
      6: 'Surgeon Approval',
      7: 'Template Design',
      8: 'G Code',
      9: 'CNC',
      10: 'Final QC',
      11: 'Shipped'
    } :

    {
      1: hasRole(profile, ['mri_center']) ? 'Ready to Upload MRI' : 'Waiting for MRI',
      2: 'In Progress',
      'MRI':'In Progress',
      3: 'In Progress',
      "MRI_QC": 'In Progress',
      4: 'In Progress',
      'Planning_1':'In Progress',
      5: hasRole(profile, ['distributor', 'surgeon','partner_admin']) ? 'Surgeon Approval Ready' : 'Approval Ready',
      'Planning_2': 'Approval Ready',
      6: 'Surgeon Approved',
      'Surgeon_approval': 'Surgeon Approved',
      7: 'Manufacturing',
      'Template_design': 'Manufacturing',
      8: 'Manufacturing',
      'G_code': 'Manufacturing',
      9: 'Manufacturing',
      'CNC': 'Manufacturing',
      10: 'Manufacturing',
      'Final_QC': 'Manufacturing',
      11: 'Shipped',
      'Shipped': 'Shipped'
    }


  const handleClose = () => {
    setState({...state, dialogFlagOpen: false});
  };

  const handleSlotClose = () => {
    setState({...state, dialogMessageOpen: false});

  }
  console.log(state)
  const handleSubmit = () => {
    axios({
      url: `https://${api_url}/api/case?case_id=${state.rowData.case_id}&update=remove_flag`,
      method: 'put',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
          setState({...state, dialogFlagOpen: false})
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
        setState({...state, dialogFlagOpen: false})
        window.location.reload()
        }

      }
    );
  }

  const handleAssign = () => {
    axios({
      url: `https://${api_url}/api/assign_command`,
      method: 'post',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
          setState({...state, dialogFlagOpen: false})
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
        setState({...state, dialogFlagOpen: false})
        window.location.reload()
        }

      }
    );
  }



  const [state, setState] = useState({
    adminColumns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: false, render:rowData => {
          return (
            <div>
            <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '0.72rem'
          }, defaultSort: 'asc'
      },
       {
        title: 'Partner', field: 'site', filtering: 'false',
        // lookup: {
        //           "EU": 'Houston',
        //           "US": 'Dallas',
        //           "KR": 'Korea',
        //     },
        emptyValue: "",
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      { title: 'Patient Last Name', field:'Patient.Last_Name', filtering: false,
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      { title: 'Patient First Name', field:'Patient.First_Name', filtering: false,
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      // { title: 'Patient Sex', field:'Patient.Sex', filtering: false,
      //   lookup: {
      //     'male': 'male',
      //     'female': 'female'
      //   },
      //   cellStyle: {
      //     fontSize: '0.9rem'
      //   }
      // },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '0.72rem'
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'DOS', field:'Patient.Date_of_Surgery', filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '0.72rem'
        },
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      {
        title: 'Expedite', field: 'expedite', type: 'boolean'
      },
      { title: 'Status', field:'case_status', filtering: true, 
        lookup: lookup,
        // emptyValue: "New Order",
        cellStyle:
          rowData =>
          {
            // console.log(rowData)
            return(rowData !== 13 ?
                      ({backgroundColor: '#e7f5f8',
                        color: '#0a7088',
                        textAlign: 'center',
                        fontSize: '0.72rem',
                        fontWeight: 800})

                        :
                      ({
                        backgroundColor: "#990000",
                        backgroundImage: "linear-gradient(to right, #bdc3c7, #2c3e50)",
                        color: 'white',
                        textAlign: 'center',
                        fontSize: '0.72rem'
                      }))
          }

      },
      // {
      //   title: 'Site', field: 'geo', filtering: 'false',
      //   lookup: {
      //             "EU": 'Houston',
      //             "US": 'Dallas',
      //             "KR": 'Korea',
      //       },
      //   emptyValue: "",
      // },
      {
        title: 'Flag', field: 'flag_status', filtering: 'false', editable: 'never', type:"text", cellStyle:
        rowData =>
          {
            return(rowData.includes("no_flag") ?
              null

              :
              ({
                  backgroundColor: '#fff0f0',
                  color: '#ad3f3f',
                  textAlign: 'center',
                  fontSize: '0.72rem',
                  fontWeight: 800
              }))
          }
      },
      {
        title: 'Expert Flag', field:'expert_flag', type: 'boolean', editable: 'never'
      },
      {
        title: 'Assigned To', field:'assigned', editable: 'never', cellStyle: {
          fontSize: '0.72rem'
        }
      },
      {
        title: 'Femur Slot', field: 'femur_slot', filtering: 'false', type: "boolean", emptyValue: <Check />,
        cellStyle: {
          textAlign: 'center'
        }
      },
      {
        title: 'Tibia Slot', field: 'tibia_slot', filtering: 'false', type: "boolean", emptyValue: <Check />,
        cellStyle: {
          textAlign: 'center'
        }
      }
    ],

    columns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: false, render:rowData => {
          return (
            <div>
            <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '0.72rem'
          }, defaultSort: hasRole(profile, ['distributor']) ? 'asc' : null
      },
      // { title: 'PO #', field:'po_number', filterting: false, editable: (row, rowData) => {
      //     return rowData && !
      //     rowData.po_number
      //   },
      //   cellStyle: {
      //     fontSize: '0.9rem'
      //   }
      // },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '0.72rem'
        }
      },

      // { title: 'Patient Name', field:'Patient.Last_Name', editable: "never", filtering: false, render: rowData => {
      //   return(
      //     <div>
      //       {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
      //     </div>
      //   )},
      //   cellStyle: {
      //     fontSize: '0.9rem'
      //   }
      // },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '0.72rem'
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },      
      { title: 'DOS', field:'Patient.Date_of_Surgery', editable: "never", filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '0.72rem'
        }, defaultSort: hasRole(profile, ['surgeon']) ? 'asc' : null,
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      { title: 'Implant', field:'Implant', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      { title: 'Hospital', field:'Hospital.Office_Name', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      { title: 'Status', field:'case_status', filtering: 'false',
        editable: 'never',
        lookup: lookup,
        emptyValue: "New Order",
        cellStyle: {
          backgroundColor: '#e7f5f8',
          color: '#0a7088',
          textAlign: 'center',
          fontSize: '0.72rem',
          fontWeight: 800
        }
      }
    ],
    hosColumns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: false, render:rowData => {
          return (
            <div>
            <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '0.72rem'
          }, defaultSort: hasRole(profile, ['distributor']) ? 'asc' : null
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      { title: 'Patient Name', field:'Patient.Last_Name', editable: "never", filtering: false, render: rowData => {
        return(
          <div>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '0.72rem'
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'DOS', field:'Patient.Date_of_Surgery', editable: "never", filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '0.72rem'
        }, defaultSort: hasRole(profile, ['surgeon']) ? 'asc' : null,
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      { title: 'Surgery Side', field:'Patient.Side_of_Body', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '0.72rem'
        }
      },
      { title: 'Status', field:'case_status', filtering: 'false',
        editable: 'never',
        lookup: lookup,
        emptyValue: "New Order",
        cellStyle: {
          background: 'linear-gradient(315deg, #045de9 0%, #09c6f9 74%)',
          backgroundColor: "#045de9",
          color: 'white',
          textAlign: 'center',
          fontSize: '.7em'
        }
      }
    ]
  });

    console.log(state)

  if(state.data){
    console.log(state.data)
    if(state.data.notLoggedIn){

      setAuthenticated(false);
      setAuthBody({role: 'visitor'});
      alert("You have been logged out due to inactivity. Please log in again.");
      localStorage.removeItem("columnFilters");
    }
  }

  else if (loading) {
    return (
      <div className={classes.loadingScreen}>
        <div className={classes.loadingLogoWrap}>
          <img
            className={classes.loadingLogo}
            src={logo}
            alt="Lento Medical Innovation"
          />
        </div>
      </div>
    );
  }

  const pageTitle = hasRole(profile, ['hospital']) ? 'Surgery List' : 'Active Cases';
  const activeCaseCount = Array.isArray(state.data) ? state.data.length : 0;
  const roleLabel = String(role || 'user').replace(/_/g, ' ');
  const canAssign = hasRole(profile, ['super_admin', 'write_admin']);
  const canClearFilters = hasRole(profile, ['super_admin', 'write_admin', 'read_admin']);

  return (
    <ThemeProvider theme={theme}>
      <main className={classes.page}>
        <div className={classes.shell}>
          <section className={classes.hero}>
            <div className={classes.heroCopy}>
              <p className={classes.eyebrow}>Case management</p>
              <h1 className={classes.heroTitle}>{pageTitle}</h1>
              <p className={classes.heroSubtitle}>
        
              </p>
            </div>

            <div className={classes.heroMeta}>
              <span className={classes.metaPill}>{activeCaseCount} active cases</span>
              <span className={classes.metaPill}>Role: {roleLabel}</span>
            </div>
          </section>

          {(canAssign || canClearFilters) && (
            <section className={classes.actionBar}>
              <div className={classes.actionCopy}>
                <p className={classes.actionTitle}>Case tools</p>
                <p className={classes.actionHint}>
         
                </p>
              </div>

              <div className={classes.actionButtons}>
                {canAssign && (
                  <button
                    type="button"
                    className={`${classes.actionButton} ${classes.primaryButton}`}
                    onClick={handleAssign}
                  >
                    Assign cases
                  </button>
                )}

                {canClearFilters && (
                  <button
                    type="button"
                    className={`${classes.actionButton} ${classes.secondaryButton}`}
                    onClick={clearFilter}
                  >
                    Clear saved filters
                  </button>
                )}
              </div>
            </section>
          )}

          <section
            className={`${classes.tableCard} ${
              hasRole(profile, ['super_admin', 'write_admin', 'read_admin'])
                ? classes.adminTable
                : ''
            }`}
            aria-label={pageTitle}
          >
            <div className={classes.tableScroller}>
              <MaterialTable
      tableRef={tableRef}
      title={hasRole(profile, ['hospital']) ? "Surgery List" : "Active List"}
      columns={hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ? state.adminColumns :
        hasRole(profile, ['hospital']) ?
        state.hosColumns
        :
        state.columns
      }
      data={state.data}
      icons={tableIcons}
      // onSearchChange={handleSearchChange}
      onSearchChange={(e) => console.log("search changed: " + e)}
      // onFilterChange={(e) => console.log("filter changed: " + e.current)}
      onQueryChange={(e) => console.log("table changed: " + e)}
      actions={
        hasRole(profile, ['super_admin', 'write_admin']) ? 
        [{
          icon: tableIcons.Flag,
          tooltip: 'Reset Flag',
          onClick: (event, rowData) => {
            setState({...state, dialogFlagOpen: true, rowData})
        }
        }
        ]
        :
        null
      }

      editable={
        hasRole(profile, ['super_admin', 'write_admin', 'distributor']) ?
        {
        isEditable:rowData=> hasRole(profile, ['distributor']) ? !rowData.po_number
        : rowData
        ,
        onRowUpdate: (newData, oldData) =>
           new Promise((resolve, reject) => {
             setTimeout(() => {
               {
                 {/*const data = [...data.data];
                 const index = data.indexOf(oldData);
                 data[index] = newData;*/}
                 const data = [...state.data];
                 const index = data.indexOf(oldData);
                 data[index] = newData;

                console.log(newData)
                if(oldData.femur_slot != newData.femur_slot ){
                 if((newData.femur_slot == true) || (newData.femur_slot == false)){
                     axios({
                       url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=slotSkip&femur=${newData.femur_slot == true ? 1 : 0}`,
                       method: 'put',
                       headers: {
                         'x-access-token' : token
                       }
                     }).then(res=> {
                       if(res.data.message){
                         setState({...state, dialogMessageOpen: true, oldData, error: res.data.message})
                       }
                       else if(res.data.notLoggedIn){
                         setAuthenticated(false)
                         setAuthBody({role: 'visitor'})
                         alert("You have been logged out due to inactivity. Please log in again.")
                       }
                       else{
                         console.log(data[index].femur_slot)
                         setState({...state, data})
                         alert("Femur Slot has successfully changed.\nReminder: You can change only one slot at a time.")
                       }

                     })
                   }
                 }
                 else if(oldData.tibia_slot != newData.tibia_slot){
                   axios({
                     url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=slotSkip&tibia=${newData.tibia_slot == true ? 1 : 0}`,
                     method: 'put',
                     headers: {
                       'x-access-token' : token
                     }
                   }).then(res=> {
                     if(res.data.message){
                       setState({...state, dialogMessageOpen: true, oldData, error: res.data.message})
                     }
                     else if(res.data.notLoggedIn){
                       setAuthenticated(false)
                       setAuthBody({role: 'visitor'})
                       alert("You have been logged out due to inactivity. Please log in again.")
                     }
                     else{
                       setState({...state, data})
                       alert("Tibia Slot has successfully changed.\nReminder: You can change only one slot at a time.")

                     }

                   })
                 }
                 else if (oldData.expedite != newData.expedite){
                   console.log("hi")
                   axios({
                     url: `https://${api_url}/api/case?case_id=${oldData.case_id}&update=expedite&expedite=0`,
                     method: 'put',
                     headers: {
                       'x-access-token' : token
                     }
                   }).then(res=> {
                     if(res.data.message){
                       setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                       window.location.reload()
                     }
                     else if(res.data.notLoggedIn){
                       setAuthenticated(false)
                       setAuthBody({role: 'visitor'})
                       alert("You have been logged out due to inactivity. Please log in again.")
                     }
                     else{
                        setState({...state, data})
                        alert(`Case ${oldData.case_id} has been unassigned and expedite status has been removed. To expedite and assign an expert, go to the case details page `)
                        window.location.reload()
                     }
                   })
                 }
               else if (oldData.geo != newData.geo){
                 axios({
                   url: `https://${api_url}/api/case?case_id=${oldData.case_id}&update=geo&geo=${newData.geo}`,
                   method: 'put',
                   headers: {
                     'x-access-token' : token
                   },
                   data: newData
                 }).then(res=> {
                   if(res.data.message){
                     setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                     // window.location.reload()
                   }
                   else if(res.data.notLoggedIn){
                     setAuthenticated(false)
                     setAuthBody({role: 'visitor'})
                     alert("You have been logged out due to inactivity. Please log in again.")
                   }
                   else{
                      setState({...state, data})
                      alert(`Case ${oldData.case_id} geo has been changed.`)
                      window.location.reload()
                   }
                 })
               }
               else if (oldData.po_number !== newData.po_number){
                 axios({
                   url: `https://${api_url}/api/case?case_id=${oldData.case_id}&update=new_po`,
                   method: 'put',
                   headers: {
                     'x-access-token' : token
                   },
                   data: newData
                 }).then(res=> {
                   if(res.data.message){
                     setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                     window.location.reload()
                   }
                   else if(res.data.notLoggedIn){
                     setAuthenticated(false)
                     setAuthBody({role: 'visitor'})
                     alert("You have been logged out due to inactivity. Please log in again.")
                   }
                   else{
                      setState({...state, data})
                      alert("PO Number has been issued successfully")
                      window.location.reload()


                   }
                 })
               }
                 else if (newData.case_status > oldData.case_status || newData.case_status == 1){
                   reject(new Error(newData))
                   alert("Error: Status will not change. Please choose statuses previous to the current status.")

                 }
                 else if (oldData.case_status == 11 && !oldData.postpone){
                   reject(new Error(newData))
                   alert("Error: Status will not change. Order has already been shipped.")
                 }
                 else if(oldData.case_status == newData.case_status){
                   if(oldData == newData){
                     reject(new Error(newData))
                     alert("Error: Status will not change. Status already in progress.")
                   }
                   else{
                    axios({
                      url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=edit_patient`,
                      method: 'put',
                      headers: {
                        'x-access-token' : token
                      },
                      data: newData

                    }).then(res=> {
                      if(res.data.message){
                        console.log(newData)
                        setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                      }
                      else if(res.data.notLoggedIn){
                        setAuthenticated(false)
                        setAuthBody({role: 'visitor'})
                        alert("You have been logged out due to inactivity. Please log in again.")
                      }
                      else{
                        alert(`Case ${oldData.case_id} patient data has been successfully updated.`)
                        window.location.reload()
                      }
                    })


                 }
               }
                 else if (oldData.case_status !== newData.case_status){
                   setState({ ...state, data });
                   console.log(newData)
                   console.log(data)
                   console.log(state)
                   axios({
                     url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=change_case_status&change_status=${newData.case_status}`,
                     method: 'put',
                     headers: {
                       'x-access-token' : token
                     }
                   }).then(res=> {
                     if(res.data.message){
                       setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                       window.location.reload()
                     }
                     else if(res.data.notLoggedIn){
                       setAuthenticated(false)
                       setAuthBody({role: 'visitor'})
                       alert("You have been logged out due to inactivity. Please log in again.")
                     }
                     else{
                       alert(`Case ${oldData.case_id} patient data has been successfully updated.`)

                        window.location.reload()
                     }
                   })
                   ;
                 }


               }
               resolve()
             }, 1000);
           })
      }
      :
      null

      }
      localization={{
          pagination: {
              labelDisplayedRows: '{from}-{to} of {count}'
          },
          toolbar: {
              nRowsSelected: '{0} row(s) selected'
          },
          header: {
              actions: hasRole(profile, ['super_admin', 'write_admin']) ? 'Edit'
              :
              'Create'
          },
          body: {
              emptyDataSourceMessage: 'No records to display',
              filterRow: {
                  filterTooltip: 'Filter'
              },
              editTooltip: "Create",

          }
      }}
      options={{
        actionsColumnIndex: hasRole(profile, ['super_admin', 'write_admin']) ? 9 : 1,
        sorting: true,
        pageSize: 20,
        pageSizeOptions: [10, 20, 50, 100],
        filtering: false,
        padding: 'dense',
        tableLayout: 'fixed',
        showTitle: false,
        columnsButton: true,
        draggable: false,
        emptyRowsWhenPaging: false,
        headerStyle: {
          backgroundColor: '#f2f7f9',
          color: '#345064',
          fontSize: '0.82rem',
          fontWeight: 800,
          whiteSpace: 'normal',
          lineHeight: 1.2,
          textAlign: 'center'
        },
        rowStyle: {
          color: '#263f50',
          fontSize: '0.82rem',
          textAlign: 'center'
        },
        filterCellStyle: {
          backgroundColor: '#fbfdfe'
        },
        searchFieldStyle: {
          width: 230,
          fontSize: '0.9rem'
        }
      }}
      style={{
        width: '100%',
        boxShadow: 'none',
        fontSize: '0.82rem'
      }}
              />
            </div>
          </section>
        </div>
      </main>
    <Dialog open={state.dialogFlagOpen} onClose={handleClose} aria-labelledby="form-dialog-title" PaperProps={{ className: classes.dialogPaper }}>
      <DialogTitle id="form-dialog-title">
        <h2 className={classes.dialogTitle}>Reset case flag?</h2>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.dialogText}>
        Flag will reset for Case: {state.rowData ? state.rowData.case_id : null}.
        { state.rowData ?
          state.rowData.case_status == 2 ?
          " Are you sure you want to reset the flag or RESCAN? If RESCAN, please click case and click RESCAN button."
          :
          " Are you sure you want to reset the flag?"

          :
          null
        }
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <button type="button" className={classes.cancelButton} onClick={handleClose}>
          Cancel
        </button>
        <button type="button" className={classes.dangerButton} onClick={handleSubmit}>
          Reset flag
        </button>
      </DialogActions>
    </Dialog>
    <Dialog open={state.dialogMessageOpen} onClose={handleSlotClose} aria-labelledby="slot-dialog-title" PaperProps={{ className: classes.dialogPaper }}>
      <DialogTitle id="slot-dialog-title">
        <h2 className={classes.dialogTitle}>Unable to update slot</h2>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.dialogText}>
        {state.oldData ? state.oldData.case_id : null} will not change slot. {state.error ? state.error.replace("_", " ") : null}.
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <button type="button" className={`${classes.actionButton} ${classes.primaryButton}`} onClick={handleSlotClose}>
          OK
        </button>
      </DialogActions>
    </Dialog>
    </ThemeProvider>
  );
};

export default ActiveList;